import { gql, TypedDocumentNode } from '@apollo/client';
import type { Customer } from '../models/Customer';

export const ADD_CUSTOMER_MUTATION: TypedDocumentNode<{ added: boolean }, { input: Customer }> = gql`
  mutation AddCustomer($input: CustomerModelInput!) {
    added: addCustomer(input: $input)
  }
`;

export const UPDATE_CUSTOMER_MUTATION: TypedDocumentNode<{ updatedCustomer: Customer }, { id: number, input: Customer }> = gql`
  mutation UpdateCustomer($id: Int!, $input: CustomerModelInput!) {
    updatedCustomer: updateCustomer(id: $id, input: $input) {
      id,
      name,
      address,
      city,
      zip,
      contactId
    }
  }
`;

export const DELETE_CUSTOMER_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteCustomerById($id: Int!) {
    deleted: deleteCustomerById(id: $id)
  }
`;
